var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layout layout-with-header"},[_c('pai-header'),_c('div',{staticClass:"main-conn"},[_c('router-view')],1),_c('common-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }